/** Ignore browser chrome, pinch zoom and desktop resizing when docking chat. */
export function webKeyboardInset({ width, layoutHeight, visualHeight, offsetTop, scale, editing }: {
  width: number; layoutHeight: number; visualHeight: number; offsetTop: number; scale: number; editing: boolean;
}): number {
  if (width >= 768 || !editing || Math.abs(scale - 1) > 0.01) return 0;
  const overlap = layoutHeight - visualHeight - offsetTop;
  return overlap > 120 ? Math.max(0, Math.round(overlap)) : 0;
}
